<template>
  <b-container class="custom-container">
    <b-navbar type="dark" variant="white" class="center-screen p-0">
      <b-form
        @submit="submitSearchField"
        @reset="resetSearchField"
        class="nav-search-container d-flex justify-content-between w-100"
      >
        <div class="d-flex w-100">
          <b-form-input
            placeholder="Search for file name, file type or keyword"
            class="search-input w-100 my-2"
            type="search"
            v-model="search"
          ></b-form-input>
        </div>
        <div>
          <b-button type="submit" variant="primary">
            <b-icon scale="1" icon="search" aria-hidden="true"></b-icon>
          </b-button>
        </div>
      </b-form>
    </b-navbar>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      search: ''
    }
  },
  methods: {
    submitSearchField(e) {
      e.preventDefault()
      this.$emit('searchedFile', this.search)
    },
    resetSearchField(e) {
      e.preventDefault()
      this.search = ''
      this.$emit('searchedFile', this.search)
    }
  },
  watch: {
    search(newVal, oldVal) {
      if (!newVal) this.$emit('searchedFile', this.search)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  border-color: white;
  &:hover,
  &:focus {
    border-color: white;
  }
}
.append-icon {
  top: 32px;
  right: 8px;
}
.center-screen {
  min-height: auto;
  margin-top: -105px;
  box-shadow: 0px 0px 20px #3640521a;
  border-radius: 8px;
}
.vertical {
  border-left: 1px solid #00000029;
}
.btn {
  height: 66px;
  box-shadow: 0px 0px 20px #3640521a;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.filter-input {
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-input {
  &:focus::placeholder {
    opacity: 0.3;
  }

  &::placeholder {
    color: black;
    opacity: 0.6;
    font-weight: bold;
    font-size: 1.1rem;
  }
}
</style>
